export const OFF = 'off';
export const ONE_TIME_CODE = 'one-time-code';
